"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VaultIdentifier = exports.ContextIdentifier = exports.VaultStatus = exports.SerializablePsyMarket = exports.WalletUser = exports.GeneratedUser = exports.ExternalUser = void 0;
const anchor = __importStar(require("@project-serum/anchor"));
const serum_1 = require("@project-serum/serum");
const serum_2 = require("./serum");
const web3_js_1 = require("@solana/web3.js");
const __1 = require("..");
const sdk_1 = require("../sdk");
const constants_1 = require("./constants");
const spl_token_1 = require("@solana/spl-token");
class ExternalUser {
    constructor(userAddress) {
        this.userAddress = userAddress;
    }
    getSigners() {
        return undefined;
    }
    getPublicKey() {
        return this.userAddress;
    }
    getAssociatedTokenAccount(mint) {
        return spl_token_1.Token.getAssociatedTokenAddress(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, mint, this.userAddress);
    }
}
exports.ExternalUser = ExternalUser;
/**
 * user that has a generated keypair
 */
class GeneratedUser {
    constructor(keyPair, userAccount, userAccountBump, quoteTokenAccount, underlyingTokenAccount, optionTokenAccount, derivativeTokenAccount, earlyAccessTokenAccount) {
        this.keyPair = keyPair;
        this.userAccount = userAccount;
        this.userAccountBump = userAccountBump;
        this.quoteTokenAccount = quoteTokenAccount;
        this.underlyingTokenAccount = underlyingTokenAccount;
        this.optionTokenAccount = optionTokenAccount;
        this.derivativeTokenAccount = derivativeTokenAccount;
        this.earlyAccessTokenAccount = earlyAccessTokenAccount;
    }
    getSigners() {
        return [this.keyPair];
    }
    getPublicKey() {
        return this.keyPair.publicKey;
    }
    getAssociatedTokenAccount(mint) {
        return spl_token_1.Token.getAssociatedTokenAddress(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, mint, this.getPublicKey());
    }
}
exports.GeneratedUser = GeneratedUser;
class WalletUser {
    constructor(wallet, userAccount, userAccountBump, quoteTokenAccount, underlyingTokenAccount, optionTokenAccount, derivativeTokenAccount, earlyAccessTokenAccount) {
        this.wallet = wallet;
        this.userAccount = userAccount;
        this.userAccountBump = userAccountBump;
        this.quoteTokenAccount = quoteTokenAccount;
        this.underlyingTokenAccount = underlyingTokenAccount;
        this.optionTokenAccount = optionTokenAccount;
        this.derivativeTokenAccount = derivativeTokenAccount;
        this.earlyAccessTokenAccount = earlyAccessTokenAccount;
    }
    getAssociatedTokenAccount(mint) {
        return spl_token_1.Token.getAssociatedTokenAddress(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, mint, this.getPublicKey());
    }
    getSigners() {
        return undefined;
    }
    getPublicKey() {
        return this.wallet.publicKey;
    }
}
exports.WalletUser = WalletUser;
class SerializablePsyMarket {
    constructor({ marketProxy, openOrders, openOrdersBump, marketAuthority, marketAuthorityBump, vaultSigner, referralPcTokenAccount, }) {
        this.marketProxy = marketProxy;
        this.openOrders = openOrders;
        this.openOrdersBump = openOrdersBump;
        this.marketAuthority = marketAuthority;
        this.marketAuthorityBump = marketAuthorityBump;
        this.vaultSigner = vaultSigner;
        this.referralPcTokenAccount = referralPcTokenAccount;
    }
    static async deserialize(serialized, provider, optionMarketKey) {
        const intermediateMarket = JSON.parse(serialized, (k, v) => {
            if (k == "_bn") {
                return new anchor.BN(v, "hex");
            }
            return v;
        });
        console.log(JSON.stringify(intermediateMarket, null, 2));
        console.log("type:", intermediateMarket.marketProxy.proxyProgramId);
        console.log("proxy pid:", intermediateMarket.marketProxy.proxyProgramId);
        console.log("dex pid:", intermediateMarket.marketProxy.dexProgramId);
        console.log("market key", intermediateMarket.marketProxy.market);
        const proxyProgramId = new web3_js_1.PublicKey(intermediateMarket.marketProxy.proxyProgramId);
        const dexProgramId = new web3_js_1.PublicKey(intermediateMarket.marketProxy.dexProgramId);
        const marketKey = new web3_js_1.PublicKey(intermediateMarket.marketProxy.market);
        console.log("proxy pid:", proxyProgramId);
        console.log("dex pid:", dexProgramId);
        console.log("market key:", marketKey);
        const marketProxy = await new serum_1.MarketProxyBuilder()
            .middleware(new serum_1.OpenOrdersPda({
            proxyProgramId: proxyProgramId,
            dexProgramId: dexProgramId,
        }))
            .middleware(new serum_2.Validation(optionMarketKey, intermediateMarket.marketAuthorityBump))
            .middleware(new serum_1.Logger())
            .middleware(new serum_1.ReferralFees())
            .load({
            connection: provider.connection,
            market: marketKey,
            dexProgramId: dexProgramId,
            proxyProgramId: proxyProgramId,
            options: { commitment: "recent" },
        });
        // Overwrite market proxy with the actual market proxy object
        return new SerializablePsyMarket({
            ...intermediateMarket,
            marketProxy,
        });
    }
    serialize() {
        const intermediateMarket = {
            marketProxy: {
                market: this.marketProxy.market.publicKey,
                dexProgramId: this.marketProxy.dexProgramId,
                proxyProgramId: this.marketProxy.proxyProgramId,
            },
            openOrders: this.openOrders,
            openOrdersBump: this.openOrdersBump,
            marketAuthority: this.marketAuthority,
            marketAuthorityBump: this.marketAuthorityBump,
            vaultSigner: this.vaultSigner,
            referralPcTokenAccount: this.referralPcTokenAccount,
        };
        return JSON.stringify(intermediateMarket);
    }
}
exports.SerializablePsyMarket = SerializablePsyMarket;
// export enum VaultStatus {
//   CompleteAuction = "completeAuction",
//   RollToNextOption = "rollToNextOption",
//   SetOptionParameters = "setOptionParameters",
//   MintOptions = "mintOptions",
//   InitializeAuction = "initializeAuction",
// }
exports.VaultStatus = {
    CompleteAuction: { completeAuction: {} },
    RollToNextOption: { rollToNextOption: {} },
    SetOptionParameters: { setOptionParameters: {} },
    MintOptions: { mintOptions: {} },
    InitializeAuction: { initializeAuction: {} },
};
// Use an identity context 
class ContextIdentifier {
    constructor(identityContext) {
        this.identityContext = identityContext;
    }
    programId() {
        if (this.identityContext.getType() === "structured") {
            return constants_1.STRUCTURED_ID;
        }
        else if (this.identityContext.getType() === "structuredGeneric") {
            return constants_1.STRUCTURED_GENERIC_ID;
        }
        else {
            throw new Error("Invalid identity context type");
        }
    }
    idl() {
        if (this.identityContext.getType() === "structured") {
            return __1.structuredIdl;
        }
        else if (this.identityContext.getType() === "structuredGeneric") {
            return __1.structuredGenericIdl;
        }
        else {
            throw new Error("Invalid vault type");
        }
    }
    ;
    createProgram(provider) {
        return new anchor.Program(this.idl(), this.programId(), provider);
    }
    asIdentityContext() {
        return this.identityContext;
    }
}
exports.ContextIdentifier = ContextIdentifier;
class VaultIdentifier {
    constructor(vaultType, primarySymbol, secondarySymbol) {
        this.vaultType = vaultType;
        this.primarySymbol = primarySymbol.toUpperCase();
        this.secondarySymbol = secondarySymbol === null || secondarySymbol === void 0 ? void 0 : secondarySymbol.toUpperCase();
    }
    idl() {
        if (this.vaultType === "call") {
            return __1.structuredIdl;
        }
        else if (this.vaultType === "put") {
            return __1.structuredGenericIdl;
        }
        else {
            throw new Error("Invalid vault type");
        }
    }
    ;
    programId() {
        if (this.vaultType === "call") {
            return constants_1.STRUCTURED_ID;
        }
        else if (this.vaultType === "put") {
            return constants_1.STRUCTURED_GENERIC_ID;
        }
        else {
            throw new Error("Invalid vault type");
        }
    }
    createProgram(provider) {
        return new anchor.Program(this.idl(), this.programId(), provider);
    }
    asIdentityContext() {
        if (this.vaultType === "call") {
            return new sdk_1.BasicIdentityContext(constants_1.TOKENS[this.primarySymbol]);
        }
        else if (this.vaultType === "put") {
            return new sdk_1.GenericIdentityContext(constants_1.TOKENS["USDC"], constants_1.TOKENS[this.primarySymbol], constants_1.PUT_WEEKLY_IDENTIFIER);
        }
        else {
            throw new Error("Invalid vault type");
        }
    }
}
exports.VaultIdentifier = VaultIdentifier;
